<template>
<div>
    <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert_success" v-if="alert_show === true">เพิ่มวันหยุดพนักงานสัปดาห์เรียบร้อย</v-alert>
        <v-alert type="success" class="alert_success" v-if="alert_show_delete === true">ลบวันหยุดพนักงานสัปดาห์เรียบร้อย</v-alert>
        <v-alert type="success" class="alert_success" v-if="alert_show_approve_leave === true">อนุมัติการลาเรียบร้อย</v-alert>
        <v-alert type="success" class="alert_success" v-if="alert_show_disapproved_leave === true">ไม่อนุมัติการลาเรียบร้อย</v-alert>
    </v-slide-x-reverse-transition>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <div class="d-flex justify-space-between align-center">
            <div class="d-flex align-center">
                <!-- <v-btn icon class="ma-2" @click="prev()">
                    <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <v-btn icon class="ma-2" @click="next()">
                    <v-icon>mdi-chevron-right</v-icon>
                </v-btn>-->
                <h2>
                    {{ $store.state.monthList[new Date().getMonth()].name }} {{ new Date().getFullYear() + 543 }}
                </h2>

            </div>
            <h4>
                การจัดการล่าสุด วันที่ {{ user_manage.date }} โดย {{ user_manage.name }}
            </h4>
        </div>
        <div class="name_holiday_work_schedule_list mb-3">
            <div class="d-flex align-center">
                <div class="mr-1 day_off_manage_work_schedule_list"></div>
                <div>วันหยุดร้านประจำสัปดาห์</div>
            </div>
            <div class="d-flex align-center">
                <div class="mr-1 holiday_manage_work_schedule_list"></div>
                <div>วันหยุดพนักงานสัปดาห์</div>
            </div>
            <div class="d-flex align-center">
                <div class="mr-1 special_manage_work_schedule_list"></div>
                <div>วันหยุดพิเศษของร้าน</div>
            </div>
            <div class="d-flex align-center">
                <div class="mr-1 leave_pedding_manage_work_schedule_list"></div>
                <div>พนักงานยื่นการลา กรุณาตรวจสอบ</div>
            </div>
            <div class="d-flex align-center">
                <div class="mr-1 leave_manage_work_schedule_list"></div>
                <div>พนักงานลา</div>
            </div>
        </div>
        <v-card class="pa-3 mb-3" v-for="(detail,index) in data" :key="index">
            <div>{{ detail.work_shift_name }}</div>
            <v-simple-table>
                <thead>
                    <tr>
                        <th class="text-center border_manage_work_schedule_list">
                            ชื่อ
                        </th>
                        <th class="text-center border_manage_work_schedule_list" v-for="(last_day,index) in last_day_of_month" :key="index">
                            <div>{{ last_day }}</div>
                            <div>{{ dateShort(last_day) }}</div>

                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(detail_employee,index_employee) in detail.employee" :key="index_employee">
                        <td class="text-center border_manage_work_schedule_list">{{ detail_employee.employee_name }}</td>
                        <td class="text-center border_manage_work_schedule_list" v-for="(detail_employee_date,index_employee_date) in detail_employee.date" :key="index_employee_date">
                            <div class="day_off_manage_work_schedule_list cursor_manage_work_schedule_list border_width_table_manage_work_schedule_list" v-if="detail_employee_date.weeklyHoliday"></div>
                            <div class="special_manage_work_schedule_list cursor_manage_work_schedule_list border_width_table_manage_work_schedule_list" v-else-if="detail_employee_date.special_holidays"></div>
                            <div class="leave_pedding_manage_work_schedule_list cursor_manage_work_schedule_list border_width_table_manage_work_schedule_list" @click="openExamineLeave(detail_employee_date.leave_pedding_id)" v-else-if="detail_employee_date.leave_pedding"></div>
                            <div class="leave_manage_work_schedule_list cursor_manage_work_schedule_list border_width_table_manage_work_schedule_list" v-else-if="detail_employee_date.leave"></div>
                            <v-checkbox color="#038cc1" class="ma-0" hide-details="auto" v-model="detail_employee_date.employee_holiday" @change="employeeHoliday(detail_employee.employee_id,detail_employee_date.date)" v-else></v-checkbox>
                        </td>
                    </tr>
                </tbody>
            </v-simple-table>
        </v-card>

        <div>
            <v-btn width="100%" height="50" @click="$router.push('/allschedule')">ดูเอกสารการลาของพนักงานทั้งหมด</v-btn>
        </div>
        <v-dialog v-model="open_confirm_schedule" persistent max-width="600px">
            <div v-if="loading_page_detail === true">
                <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                    <v-skeleton-loader type="article, actions"></v-skeleton-loader>
                </v-sheet>
            </div>
            <v-card v-if="loading_page_detail === false">
                <v-card-title class="justify-space-between">
                    <div>
                        การลา
                    </div>
                    <div class="cursor_manage_work_schedule_list" @click="open_confirm_schedule = false">
                        <v-icon>mdi-close</v-icon>
                    </div>
                </v-card-title>

                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <div class="text_confirm_schedule mb-2">ชื่อ : {{ leave_detail.nickname }}</div>
                                <div class="text_confirm_schedule mb-2">ประเภทการลา : {{ leave_detail.type }}</div>
                                <div class="text_confirm_schedule mb-2">วันลา : {{ leave_detail.start_date_be }} - {{ leave_detail.end_date_be }}</div>
                                <div class="text_confirm_schedule mb-2">เหตุผลการลา : {{ leave_detail.description }}</div>
                                <div class="grid_confirm_schedule">
                                    <div class="mr-1">
                                        <v-btn class="pa-3" color="success" width="100%" height="65" @click="examineLeaveUpdate(2)">
                                            <div>อนุมัติการลา</div>
                                        </v-btn>
                                    </div>
                                    <div class="ml-1">
                                        <v-btn class="pa-3" color="error" width="100%" height="65" @click="examineLeaveUpdate(3)">
                                            <div>ไม่อนุมัติ</div>
                                        </v-btn>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>

                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</div>
</template>

<script>
import manageworkschedule from '@/api/team/teamworkschedule/manageworkschedule.js'
export default {
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true,
            loading_page_detail: true,
            alert_show: false,
            alert_show_delete: false,
            alert_show_approve_leave: false,
            alert_show_disapproved_leave: false,
            user_manage: {
                date: '',
                name: '',
            },
            last_day_of_month: null,
            open_confirm_schedule: false,
            leave_detail: {
                id: null,
                nickname: '',
                type: '',
                start_date_be: '',
                start_date: '',
                end_date_be: '',
                end_date: '',
                description: '',
            },
            data: [],
        }
    },
    methods: {
        async manageWorkScheduleList() {

            this.loading_page = true
            this.user_manage = {
                date: '',
                name: '',
            }
            manageworkschedule.manageWorkScheduleList().then((response) => {
                if (response.data.successful === true) {
                    this.data = response.data.shift
                    this.user_manage = {
                        date: response.data.user_manage.date,
                        name: response.data.user_manage.name,
                    }
                    this.loading_page = false
                    let today = new Date();
                    let lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
                    this.last_day_of_month = lastDayOfMonth.getDate()
                }

            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async employeeHoliday(employee_id, date_holiday) {
            const data = {
                employee_id: employee_id,
                date_holiday: date_holiday,
            }
            this.alert_show = false
            this.alert_show_delete = false
            await manageworkschedule.employeeHolidayCreate(data).then((response) => {
                if (response.data.successful === true) {
                    if (response.data.type == 'create') {
                        this.alert_show = true
                        setTimeout(() => this.alert_show = false, 5000)
                    }
                    if (response.data.type == 'delete') {
                        this.alert_show_delete = true
                        setTimeout(() => this.alert_show_delete = false, 5000)
                    }

                }

            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })

            await manageworkschedule.manageWorkScheduleList().then((response) => {
                if (response.data.successful === true) {
                    this.user_manage = {
                        date: response.data.user_manage.date,
                        name: response.data.user_manage.name,
                    }
                }

            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async openExamineLeave(id) {
            this.loading_page_detail = true
            this.open_confirm_schedule = true
            this.leave_detail = {
                id: null,
                nickname: '',
                type: '',
                start_date_be: '',
                start_date: '',
                end_date_be: '',
                end_date: '',
                description: '',
            }
            manageworkschedule.examineLeave(id).then((response) => {
                if (response.data.successful === true) {
                    this.leave_detail = response.data.detail
                    this.loading_page_detail = false
                }

            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async examineLeaveUpdate(type) {
            this.open_confirm_schedule = false
            this.loading_page = true
            const data = {
                status: type
            }
            manageworkschedule.examineLeaveUpdate(this.leave_detail.id, data).then((response) => {
                if (response.data.successful === true) {
                    this.leave_detail = {
                        id: null,
                        nickname: '',
                        type: '',
                        start_date: '',
                        end_date: '',
                        description: '',
                    }
                    this.manageWorkScheduleList()
                    if (type == 2) {
                        this.alert_show_approve_leave = true
                        setTimeout(() => this.alert_show_approve_leave = false, 5000)
                    }
                    if (type == 3) {
                        this.alert_show_disapproved_leave = true
                        setTimeout(() => this.alert_show_disapproved_leave = false, 5000)
                    }

                }

            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        dateShort(date) {
            let dateObj = new Date()
            let dateName = new Date(dateObj.getFullYear(), dateObj.getMonth(), date)
            let weekday = dateName.toLocaleString("default", {
                weekday: "long"
            })
            if (weekday == 'Monday' || weekday == 'วันจันทร์') {
                weekday = 'จ'
            }
            if (weekday == 'Tuesday' || weekday == 'วันอังคาร') {
                weekday = 'อ'
            }
            if (weekday == 'Wednesday' || weekday == 'วันพุธ') {
                weekday = 'พ'
            }
            if (weekday == 'Thursday' || weekday == 'วันพฤหัสบดี') {
                weekday = 'พฤ'
            }
            if (weekday == 'Friday' || weekday == 'วันศุกร์') {
                weekday = 'ศ'
            }
            if (weekday == 'Saturday' || weekday == 'วันเสาร์') {
                weekday = 'ส'
            }
            if (weekday == 'Sunday' || weekday == 'วันอาทิตย์') {
                weekday = 'อา'
            }
            return weekday
        }
    },
    mounted() {
        this.manageWorkScheduleList()
    }
}
</script>

<style scoped>
.name_holiday_work_schedule_list {
    display: grid;
    grid-template-columns: 50% 50%;
}

.day_off_manage_work_schedule_list {
    padding: 10px;
    background: #424242;
    border-radius: 20px;
}

.special_manage_work_schedule_list {
    padding: 10px;
    background: #4caf50;
    border-radius: 20px;
}

.leave_manage_work_schedule_list {
    padding: 10px;
    background: #1976d2;
    border-radius: 20px;
}

.holiday_manage_work_schedule_list {
    padding: 10px;
    background: #fb8c00;
    border-radius: 20px;
}

.leave_pedding_manage_work_schedule_list {
    padding: 10px;
    background: #ff5252;
    border-radius: 20px;
}

.border_width_table_manage_work_schedule_list {
    width: 20px;
    margin: auto;
}

.border_manage_work_schedule_list {
    border: thin solid rgba(0, 0, 0, 0.12);
}

.cursor_manage_work_schedule_list {
    cursor: pointer;
}

.text_confirm_schedule {
    font-size: 22px;
}

.grid_confirm_schedule {
    display: grid;
    grid-template-columns: 50% 50%;
}
</style>
